import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext } from "react";
import MediaPreview from "./components/MediaPreview";
import TextPreview from "./components/TextPreview";
import AddAssetButton from "./components/AddAssetButton";
import { PLACEMENT } from "components/ui/utils/constant";
import { formatNumber } from "utils/formatNumber";

const YoutubeShortPreview = (post) => {
    const {
        user_name,
        username,
        user_image,
        text,
        like_count,
        className,
        preferences,
        assets,
        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit,
        onPreferencesEdit,
        onTitleEdit,
        allPosts = []
    } = post;

    const network = "youtube";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == network)?.[0];

    // Cambiado de REEL a SHORT
    if (post?.preferences?.media_product_type != "SHORT") return <></>;

    return (<>
        <div className={`flex flex-col !w-auto !h-auto !p-0 !overflow-hidden aspect-[9/16] !bg-gray-900 relative -mb-2 ${className}`}>
            <MediaPreview 
                asset={assets?.[0]} 
                parentClassName="!block bg-gray-900"
                className={`object-cover aspect-[9/16] !pointer-events-auto w-full`} 
                network={network}
                isEditable={isEditable}
                onAssetDelete={() => onAssetDelete(postIndex, 0)}
                onAssetEdit={(src) => onAssetEdit(postIndex, 0, src)}
                buttonsPlacement="top-end"
                videoControls={false}
            />
            {!assets?.length && 
                <div className="absolute w-[90%] left-1/2 top-9 -translate-x-1/2 -translate-y-1/2 z-[10]">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                        allPosts={allPosts}
                        placement={PLACEMENT.BOTTOM_CENTER}
                    />
                </div>
            }
            
            {/* Botones de interacción vertical - Actualizados con íconos de YouTube */}
            <div className="absolute right-4 bottom-20 flex flex-col gap-4">
                <button className="flex flex-col items-center text-white">
                    <div className="bg-gray-800/60 p-2 rounded-full">
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>
                        </svg>
                    </div>
                    <span className="text-xs mt-1">{formatNumber(like_count || 0)}</span>
                </button>
                <button className="flex flex-col items-center text-white">
                    <div className="bg-gray-800/60 p-2 rounded-full">
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"/>
                        </svg>
                    </div>
                    <span className="text-xs mt-1">Comment</span>
                </button>
                <button className="flex flex-col items-center text-white">
                    <div className="bg-gray-800/60 p-2 rounded-full">
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M14 9V5l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11z"/>
                        </svg>
                    </div>
                    <span className="text-xs mt-1">Share</span>
                </button>
            </div>

            <div className="pointer-events-none absolute bottom-0 left-0 w-full bg-gradient-to-b from-transparent via-transparent to-black/70">
                <div className="w-full p-4">
                    <div className="flex-1 text-white !pointer-events-auto mb-3">
                        <TextPreview 
                            text={text} 
                            network={network} 
                            isEditable={isEditable}
                            isTitle={true}
                            post={post}
                            onTextEdit={(value) => onTitleEdit(postIndex, value)}
                            previewClassName="!text-white !font-semibold group-hover:!bg-secondary-500/20"
                            editClassName="p-2 !bg-secondary-500 rounded-2xl max-h-80 overflow-auto"
                        />
                    </div>
                    
                    <div className="flex items-center gap-3">
                        <img 
                            src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} 
                            className="rounded-full w-8 h-8"
                        />
                        <span className="text-white font-medium">
                            {user_name || integration?.name || username || company?.name}
                        </span>
                        <button className="ml-2 bg-red-600 text-white px-4 py-1 text-sm rounded-full">
                            Subscribe
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default YoutubeShortPreview; 